import type { CompanyType } from "kubb";
import { isArray } from "lodash-es";
import { expandRole } from "model/authRoles";
import type React from "react";
import useUserHasRoles from "../../../hooks/user/getCurrentUserRole";

interface Props {
  children: any;
  userTypes: string[] | string;
  companyType?: CompanyType | CompanyType[];
  ignoreViewerModeSwitch?: boolean;
}

export default function DisplayIfUserType(props: Props): React.ReactElement {
  const userTypes = isArray(props.userTypes)
    ? props.userTypes
    : expandRole(props.userTypes);
  const companyTypes = isArray(props.companyType)
    ? props.companyType
    : props.companyType
      ? [props.companyType]
      : undefined;

  const display = useUserHasRoles(
    userTypes,
    companyTypes,
    props.ignoreViewerModeSwitch,
  );

  return <>{display && props.children}</>;
}
